/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */
import { useSearchParams } from 'react-router-dom';
import { IS_HRWIZ_CONSOLE_ENABLED, IS_HRWIZ_HEADER_DISABLED } from '../../../constants/env';
import { useInMicrosoftTeams } from '../isInMicrosoftTeams';

/**
 * Checks if the HRWiz header is visible. It will be visible if:
 * 1. The HRWiz console is enabled
 * 2. The user is not in MS Teams
 * 3. The header is not disabled in the environment variable `REACT_APP_HRWIZ_HEADER_DISABLED`
 * 4. The query param `h_enabled` is not `false`
 *
 * The `h_enabled` variable will override any other condition when HRWiz console is enabled. The accepted values are: `true`, `false`, `1`, `0`.
 * @returns {boolean} True if the HRWiz header should be visible, false otherwise.
 */
export const useHRWizVisible = () => {
  const inMicrosoftTeams = useInMicrosoftTeams();
  const [searchParams] = useSearchParams();

  const h_enabled = searchParams.get('h_enabled');

  if (!IS_HRWIZ_CONSOLE_ENABLED) {
    return false;
  }

  if (['true', '1'].includes(h_enabled)) {
    return true;
  }

  if (['false', '0'].includes(h_enabled)) {
    return false;
  }
  return !inMicrosoftTeams && !IS_HRWIZ_HEADER_DISABLED;
};
